import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCrypt} from "../../TheCrypt";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class DropOutPresentation implements SimplePresentation {
    name:string = "DropOutPresentation";
    shouldRun():boolean {
        return !TheCrypt.model.isNextRespin;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => controller.setSkipCallback(() =>{tl.timeScale(2);}));
        tl.add([
            ()=>{
                TheCrypt.reelBackground.onSpin();
                TheCrypt.reelFrame.onSymbolsDropOut();
            },
            TheCrypt.realArea.dropOut()
        ]);
        const delay:number = tl.duration()*0.5;
        tl.add(()=>controller.finish(), delay);
        tl.addLabel("ending");

        if (TheCrypt.apiPlugin.settings.get(APISetting.FAST_SPIN)){
            tl.timeScale(1.4);
        }

    }
}